// plugins/myPlugin.js

export default {
  install(Vue) {
    //PROD
    // Vue.$baseapi = {
    //   master: '',
    //   produk: '',
    //   transaksi: '',
    //   bid: '',
    //   iklan: '',
    //   search: '',
    //   tiket: '',
    //   user: '',
    //   log: '',
    //   report: '',
    //   setup: '',
    //   monitoring: ''
    // };

    //DEV
    Vue.$baseapi = {
      master: '/master/api',
      produk: '/produk/api',
      transaksi: '/transaksi/api',
      bid: '/bid/api',
      iklan: '/iklan/api',
      search: '/search/api',
      tiket: '/tiket/api',
      user: '/user/api',
      log: '/logs/api',
      report: '/report/api',
      setup: '/setup/api',
      monitoring: '/monitoring/api'
    };
    Object.defineProperties(Vue.prototype, {
      $baseapi: {
        get() {
          return Vue.$baseapi;
        }
      }
    });
  }
};
// export default (inject) => {

//   // inject('master', '')
//   inject('produk', '')
//   inject('transaksi', '')
//   inject('bid', '')
//   inject('iklan', '')
//   inject('search', '')
//   inject('tiket', '')
//   inject('user', '')
//   inject('log', '')
//   inject('report', '')
//   inject('setup', '')
// }
